import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements OnInit, OnDestroy {
  mobileQuery: MediaQueryList;
  currentUser: any = {};
  modules: any;
  itemSidebar: any[] = [];
  MENUITEMS: any[] = [
    { state: 'starter', name: 'Turnos trámites', type: 'link', icon: 'view_list', badge: [] },
    // { state: 'record', name: 'Turnos actas', type: 'link', icon: 'view_list', badge: [] }
  ];

  private _mobileQueryListener: () => void;

  constructor(changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private route: ActivatedRoute,
    private router: Router, ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    this.itemSidebar = this.MENUITEMS;
    this.itemSidebar.push({ state: 'logout', name: 'Cerrar Sesión', type: 'link', icon: 'exit_to_app', badge: [] });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  goTo(url: any) {
    this.router.navigateByUrl('/starter', { skipLocationChange: true }).then(() => this.router.navigate(['/configuration/' + url]));
  }
}
